import { gql } from 'graphql-request'

export const UPDATE_BOOKS_STATUS = gql`
  mutation UpdateBookStatus($updateBookStatusInput: UpdateBookStatusInput!) {
    updateBookStatus(updateBookStatusInput: $updateBookStatusInput) {
      id
      status
    }
  }
`
